import type { Option, SelectOptionValue } from './SingleChoiceDropdown';

export function getOptionLabel<T extends SelectOptionValue>(option: Option<T>): string {
  return option.name;
}

export function getValueKey<T extends SelectOptionValue>(value: T | Option<T> | null | undefined): string {
  if (value === undefined) return 'uncontrolled';
  if (value === null) return 'null';
  if (typeof value === 'object') return `option:${String(value.id)}:${value.name}`;
  return `value:${typeof value}:${String(value)}`;
}

export interface DropdownSelection<T extends SelectOptionValue> {
  valueKey: string;
  selectedOption: Option<T> | null;
  search: string;
}

export interface ResolvedDropdownValue<T extends SelectOptionValue> {
  valueKey: string;
  option: Option<T> | null;
}

export function resolveDropdownSelection<T extends SelectOptionValue>(
  value: T | Option<T> | null | undefined,
  valueKey: string,
  resolvedValue: ResolvedDropdownValue<T> | null,
  selection: DropdownSelection<T> | null,
): { selectedOption: Option<T> | null; search: string } {
  const controlledOption =
    typeof value === 'object'
      ? value
      : value !== undefined && value !== null && resolvedValue?.valueKey === valueKey
        ? resolvedValue.option
        : null;
  const selectedOption = selection?.valueKey === valueKey ? selection.selectedOption : controlledOption;
  const search = selection?.valueKey === valueKey ? selection.search : (controlledOption?.name ?? '');
  return { selectedOption, search };
}
